import { useState } from "react";
import { Menu, X } from "lucide-react";

const navItems = [
  { label: "Wat we doen", target: "#wat-we-doen" },
  { label: "Diensten", target: "#diensten" },
  { label: "Categorieën", target: "#categorieen" },
];

export const Logo = ({ onClick }) => (
  <div className="ws-logo" onClick={onClick} role="button" aria-label="WS Global Trading home">
    <span className="ws-logo-main">
      ws<span className="italic-part">global</span>
    </span>
    <span className="ws-logo-sub">Trading</span>
  </div>
);

const Header = ({ onSignup, onContact }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollTo = (target) => {
    setMenuOpen(false);
    const el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <header className="ws-header">
        <div className="ws-header-inner">
          <Logo onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} />
          <nav className="ws-nav">
            {navItems.map((item) => (
              <a key={item.label} onClick={() => scrollTo(item.target)}>
                {item.label}
              </a>
            ))}
            <a onClick={onContact}>Contact</a>
          </nav>
          <div className="ws-header-actions">
            <button className="ws-btn ws-btn-lime" onClick={onSignup}>
              Vraag account aan
            </button>
            <button className="ws-btn ws-btn-dark" onClick={onSignup}>
              Account aanmaken
            </button>
            <button
              className="ws-mobile-toggle"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Menu"
            >
              {menuOpen ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>
        </div>
      </header>
      {menuOpen && (
        <div className="ws-mobile-menu">
          {navItems.map((item) => (
            <a key={item.label} onClick={() => scrollTo(item.target)}>
              {item.label}
            </a>
          ))}
          <a onClick={() => { setMenuOpen(false); onContact(); }}>Contact</a>
        </div>
      )}
    </>
  );
};

export default Header;
